import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";

import { useAuth } from "contexts/AuthContext";
import { expenseService } from "services/firestoreService";

const _expensesRemoved = [
  {
    id: 1,
    description: "Building Maintenance - Plumbing Repair",
    property: "Oakwood Apartments",
    unit: "Common Area",
    category: "Maintenance",
    subCategory: "Plumbing",
    amount: 850.75,
    date: "2025-05-12",
    vendor: "City Plumbing Services",
    status: "paid",
    paymentMethod: "Bank Transfer",
    recurring: false,
    attachments: 2
  },
  {
    id: 2,
    description: "Monthly Landscaping Service",
    property: "Parkview Residences",
    unit: "Grounds",
    category: "Maintenance",
    subCategory: "Landscaping",
    amount: 1200.00,
    date: "2025-05-05",
    vendor: "Green Thumb Landscaping",
    status: "paid",
    paymentMethod: "ACH",
    recurring: true,
    attachments: 1
  },
  {
    id: 3,
    description: "Property Insurance Premium - Q2",
    property: "All Properties",
    unit: "N/A",
    category: "Insurance",
    subCategory: "Property Insurance",
    amount: 4750.00,
    date: "2025-04-15",
    vendor: "SafeGuard Insurance Co.",
    status: "paid",
    paymentMethod: "Bank Transfer",
    recurring: true,
    attachments: 3
  },
  {
    id: 4,
    description: "HVAC System Replacement - Unit 310C",
    property: "Sunset Heights",
    unit: "310C",
    category: "Capital Expenditure",
    subCategory: "HVAC",
    amount: 6300.00,
    date: "2025-05-08",
    vendor: "Cool Air Systems",
    status: "pending",
    paymentMethod: null,
    recurring: false,
    attachments: 4
  },
  {
    id: 5,
    description: "Quarterly Property Tax Payment",
    property: "All Properties",
    unit: "N/A",
    category: "Taxes",
    subCategory: "Property Tax",
    amount: 12400.00,
    date: "2025-04-30",
    vendor: "County Tax Office",
    status: "paid",
    paymentMethod: "Check",
    recurring: true,
    attachments: 1
  },
  {
    id: 6,
    description: "Elevator Maintenance Contract",
    property: "Parkview Residences",
    unit: "Common Area",
    category: "Maintenance",
    subCategory: "Elevator",
    amount: 950.00,
    date: "2025-05-15",
    vendor: "Elevate Maintenance Co.",
    status: "pending",
    paymentMethod: null,
    recurring: true,
    attachments: 0
  },
  {
    id: 7,
    description: "Emergency Roof Repair",
    property: "Oakwood Apartments",
    unit: "Building A",
    category: "Repairs",
    subCategory: "Roofing",
    amount: 3750.00,
    date: "2025-05-10",
    vendor: "TopNotch Roofing",
    status: "paid",
    paymentMethod: "Credit Card",
    recurring: false,
    attachments: 5
  },
  {
    id: 8,
    description: "Utilities - Common Area Electricity",
    property: "Sunset Heights",
    unit: "Common Area",
    category: "Utilities",
    subCategory: "Electricity",
    amount: 875.25,
    date: "2025-05-03",
    vendor: "PowerLight Utilities",
    status: "paid",
    paymentMethod: "ACH",
    recurring: true,
    attachments: 1
  },
  {
    id: 9,
    description: "Legal Fees - Lease Agreement Updates",
    property: "All Properties",
    unit: "N/A",
    category: "Professional Services",
    subCategory: "Legal",
    amount: 2800.00,
    date: "2025-04-22",
    vendor: "Johnson & Smith Law Firm",
    status: "paid",
    paymentMethod: "Bank Transfer",
    recurring: false,
    attachments: 2
  },
  {
    id: 10,
    description: "Pest Control Services",
    property: "Oakwood Apartments",
    unit: "All Units",
    category: "Maintenance",
    subCategory: "Pest Control",
    amount: 650.00,
    date: "2025-05-17",
    vendor: "Pest-Away Services",
    status: "pending",
    paymentMethod: null,
    recurring: true,
    attachments: 0
  }
];

// expenseSummary computed from Firestore data inside component

// Tab panel component for expense categories
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

// Add PropTypes for TabPanel component
TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

function Expenses() {
  const { user } = useAuth();
  const [expenses, setExpenses] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [category, setCategory] = useState("all");

  useEffect(() => {
    if (!user) return;
    const fetchExpenses = async () => {
      try {
        const data = await expenseService.getAll(user.uid);
        setExpenses(data);
      } catch (err) {
        console.error("Failed to fetch expenses:", err);
      } finally {
        setLoadingData(false);
      }
    };
    fetchExpenses();
  }, [user]);

  const expenseSummary = {
    totalExpenses: expenses.reduce((sum, e) => sum + (e.amount || 0), 0),
    paidExpenses: expenses.filter(e => e.status === 'paid').reduce((sum, e) => sum + (e.amount || 0), 0),
    pendingExpenses: expenses.filter(e => e.status === 'pending').reduce((sum, e) => sum + (e.amount || 0), 0),
  };
  const [property, setProperty] = useState("all");
  const [dateRange, setDateRange] = useState("this-month");
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedExpense, setSelectedExpense] = useState(null);
  
  const handleMenuClick = (event, expense) => {
    setAnchorEl(event.currentTarget);
    setSelectedExpense(expense);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const handleAction = (action) => {
    // Demo functionality only
    console.log(`Action ${action} for expense ${selectedExpense?.id}`);
    handleMenuClose();
  };
  
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getStatusChip = (status) => {
    switch (status) {
      case "paid":
        return <Chip 
          label="Paid" 
          color="success" 
          size="small" 
          sx={{ minWidth: 80 }}
        />;
      case "pending":
        return <Chip 
          label="Pending" 
          color="warning" 
          size="small" 
          sx={{ minWidth: 80 }}
        />;
      default:
        return <Chip label={status} size="small" />;
    }
  };

  // Filter the expenses data based on selected filters and search
  const filteredExpenses = expenses.filter((item) => {
    // Filter by category
    if (category !== "all" && item.category !== category) {
      return false;
    }
    
    // Filter by property
    if (property !== "all" && item.property !== property && item.property !== "All Properties") {
      return false;
    }
    
    // Filter by search term (in description or vendor)
    if (search && 
      !item.description.toLowerCase().includes(search.toLowerCase()) && 
      !item.vendor.toLowerCase().includes(search.toLowerCase())) {
      return false;
    }
    
    return true;
  });

  // Calculate total for filtered expenses
  const filteredTotal = filteredExpenses.reduce((sum, item) => sum + item.amount, 0);

  // Get category names for filter dropdown
  const categories = [...new Set(expenses.map(item => item.category))];
  
  // Get property names for filter dropdown
  const properties = [...new Set(expenses.map(item => item.property))];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Grid container spacing={3}>
          {/* Summary Cards */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <Card>
                  <ArgonBox p={3} display="flex" alignItems="center">
                    <ArgonBox
                      display="grid"
                      alignItems="center"
                      justifyContent="center"
                      bgColor="info"
                      color="white"
                      width="4rem"
                      height="4rem"
                      shadow="md"
                      borderRadius="lg"
                      mr={2}
                    >
                      <AttachMoneyIcon fontSize="large" />
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonTypography variant="h5" fontWeight="bold">
                        ${expenseSummary.totalExpenses.toLocaleString()}
                      </ArgonTypography>
                      <ArgonTypography variant="caption" color="text">
                        Total Expenses (This Month)
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                </Card>
              </Grid>
              
              <Grid item xs={12} md={6} lg={3}>
                <Card>
                  <ArgonBox p={3} display="flex" alignItems="center">
                    <ArgonBox
                      display="grid"
                      alignItems="center"
                      justifyContent="center"
                      bgColor="success"
                      color="white"
                      width="4rem"
                      height="4rem"
                      shadow="md"
                      borderRadius="lg"
                      mr={2}
                    >
                      <ReceiptIcon fontSize="large" />
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonTypography variant="h5" fontWeight="bold">
                        ${expenseSummary.paidExpenses.toLocaleString()}
                      </ArgonTypography>
                      <ArgonTypography variant="caption" color="text">
                        Paid Expenses
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                </Card>
              </Grid>
              
              <Grid item xs={12} md={6} lg={3}>
                <Card>
                  <ArgonBox p={3} display="flex" alignItems="center">
                    <ArgonBox
                      display="grid"
                      alignItems="center"
                      justifyContent="center"
                      bgColor="warning"
                      color="white"
                      width="4rem"
                      height="4rem"
                      shadow="md"
                      borderRadius="lg"
                      mr={2}
                    >
                      <AssignmentIcon fontSize="large" />
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonTypography variant="h5" fontWeight="bold">
                        ${expenseSummary.pendingExpenses.toLocaleString()}
                      </ArgonTypography>
                      <ArgonTypography variant="caption" color="text">
                        Pending Expenses
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                </Card>
              </Grid>
              
              <Grid item xs={12} md={6} lg={3}>
                <Card>
                  <ArgonBox p={3} display="flex" alignItems="center">
                    <ArgonBox
                      display="grid"
                      alignItems="center"
                      justifyContent="center"
                      bgColor="error"
                      color="white"
                      width="4rem"
                      height="4rem"
                      shadow="md"
                      borderRadius="lg"
                      mr={2}
                    >
                      <AccountBalanceIcon fontSize="large" />
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonTypography variant="h5" fontWeight="bold">
                        ${(expenseSummary.totalExpenses - expenseSummary.monthlyBreakdown.Apr).toLocaleString()}
                      </ArgonTypography>
                      <ArgonTypography variant="caption" color="text">
                        Change from Last Month
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {/* Expense Charts & Breakdown */}
          <Grid item xs={12}>
            <Card>
              <ArgonBox p={3}>
                <ArgonTypography variant="h5" fontWeight="medium" mb={2}>
                  Expense Analysis
                </ArgonTypography>
                
                <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
                  <Tab label="By Category" />
                  <Tab label="By Property" />
                  <Tab label="Monthly Trend" />
                </Tabs>
                
                <TabPanel value={tabValue} index={0}>
                  <Grid container spacing={2}>
                    {Object.entries(expenseSummary.categoryBreakdown).map(([category, amount], index) => (
                      <Grid item xs={12} sm={6} md={4} key={category}>
                        <Paper 
                          elevation={1} 
                          sx={{ 
                            p: 2, 
                            display: 'flex', 
                            alignItems: 'center',
                            height: '100%'
                          }}
                        >
                          <ArgonBox
                            display="grid"
                            alignItems="center"
                            justifyContent="center"
                            bgColor={
                              index % 5 === 0 ? "info" : 
                              index % 5 === 1 ? "success" : 
                              index % 5 === 2 ? "warning" : 
                              index % 5 === 3 ? "error" :
                              "primary"
                            }
                            color="white"
                            width="3rem"
                            height="3rem"
                            borderRadius="lg"
                            mr={2}
                          >
                            {index % 5 === 0 && <BusinessIcon />}
                            {index % 5 === 1 && <AttachMoneyIcon />}
                            {index % 5 === 2 && <ReceiptIcon />}
                            {index % 5 === 3 && <AssignmentIcon />}
                            {index % 5 === 4 && <AccountBalanceIcon />}
                          </ArgonBox>
                          <Stack spacing={0}>
                            <Typography variant="subtitle2">{category}</Typography>
                            <Typography variant="h6">${amount.toLocaleString()}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {Math.round((amount / expenseSummary.totalExpenses) * 100)}% of total
                            </Typography>
                          </Stack>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </TabPanel>
                
                <TabPanel value={tabValue} index={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Paper elevation={1} sx={{ p: 2 }}>
                        <Typography variant="subtitle2" gutterBottom>Oakwood Apartments</Typography>
                        <Typography variant="h6">$15,250.00</Typography>
                        <Typography variant="caption" color="text.secondary">44% of total expenses</Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Paper elevation={1} sx={{ p: 2 }}>
                        <Typography variant="subtitle2" gutterBottom>Parkview Residences</Typography>
                        <Typography variant="h6">$12,150.00</Typography>
                        <Typography variant="caption" color="text.secondary">35% of total expenses</Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Paper elevation={1} sx={{ p: 2 }}>
                        <Typography variant="subtitle2" gutterBottom>Sunset Heights</Typography>
                        <Typography variant="h6">$7,126.00</Typography>
                        <Typography variant="caption" color="text.secondary">21% of total expenses</Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </TabPanel>
                
                <TabPanel value={tabValue} index={2}>
                  <Grid container spacing={2}>
                    {Object.entries(expenseSummary.monthlyBreakdown).map(([month, amount]) => (
                      <Grid item xs={12} sm={6} md={2.4} key={month}>
                        <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
                          <Typography variant="subtitle2" gutterBottom>{month}</Typography>
                          <Typography variant="h6">${amount.toLocaleString()}</Typography>
                          {month !== "Jan" && (
                            <Typography 
                              variant="caption" 
                              color={
                                amount > expenseSummary.monthlyBreakdown[
                                  Object.keys(expenseSummary.monthlyBreakdown)[
                                    Object.keys(expenseSummary.monthlyBreakdown).indexOf(month) - 1
                                  ]
                                ] ? "error.main" : "success.main"
                              }
                            >
                              {amount > expenseSummary.monthlyBreakdown[
                                Object.keys(expenseSummary.monthlyBreakdown)[
                                  Object.keys(expenseSummary.monthlyBreakdown).indexOf(month) - 1
                                ]
                              ] ? "↑" : "↓"} 
                              {Math.abs(Math.round((amount / expenseSummary.monthlyBreakdown[
                                Object.keys(expenseSummary.monthlyBreakdown)[
                                  Object.keys(expenseSummary.monthlyBreakdown).indexOf(month) - 1
                                ]
                              ] - 1) * 100))}% from {
                                Object.keys(expenseSummary.monthlyBreakdown)[
                                  Object.keys(expenseSummary.monthlyBreakdown).indexOf(month) - 1
                                ]
                              }
                            </Typography>
                          )}
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </TabPanel>
              </ArgonBox>
            </Card>
          </Grid>

          {/* Expenses Table */}
          <Grid item xs={12}>
            <Card>
              <ArgonBox p={3}>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                  <ArgonTypography variant="h5" fontWeight="medium">
                    Expense Transactions
                  </ArgonTypography>
                  <ArgonButton color="primary" size="small">
                    + Add Expense
                  </ArgonButton>
                </ArgonBox>
                
                {/* Filters */}
                <ArgonBox mb={3} display="flex" flexWrap="wrap" gap={2}>
                  <FormControl sx={{ minWidth: 150 }} size="small">
                    <InputLabel id="category-filter-label">Category</InputLabel>
                    <Select
                      labelId="category-filter-label"
                      value={category}
                      label="Category"
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <MenuItem value="all">All Categories</MenuItem>
                      {categories.map((cat) => (
                        <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  
                  <FormControl sx={{ minWidth: 180 }} size="small">
                    <InputLabel id="property-filter-label">Property</InputLabel>
                    <Select
                      labelId="property-filter-label"
                      value={property}
                      label="Property"
                      onChange={(e) => setProperty(e.target.value)}
                    >
                      <MenuItem value="all">All Properties</MenuItem>
                      {properties.filter(prop => prop !== "All Properties").map((prop) => (
                        <MenuItem key={prop} value={prop}>{prop}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  
                  <FormControl sx={{ minWidth: 150 }} size="small">
                    <InputLabel id="date-range-filter-label">Date Range</InputLabel>
                    <Select
                      labelId="date-range-filter-label"
                      value={dateRange}
                      label="Date Range"
                      onChange={(e) => setDateRange(e.target.value)}
                    >
                      <MenuItem value="this-month">This Month</MenuItem>
                      <MenuItem value="last-month">Last Month</MenuItem>
                      <MenuItem value="this-quarter">This Quarter</MenuItem>
                      <MenuItem value="ytd">Year to Date</MenuItem>
                      <MenuItem value="custom">Custom...</MenuItem>
                    </Select>
                  </FormControl>
                  
                  <TextField
                    size="small"
                    label="Search Expenses"
                    variant="outlined"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{ minWidth: 220 }}
                  />
                </ArgonBox>
                
                {/* Summary of filtered data */}
                <ArgonBox mb={3} p={2} bgcolor="background.default" borderRadius={1}>
                  <ArgonTypography variant="subtitle2">
                    Showing {filteredExpenses.length} expenses totaling ${filteredTotal.toLocaleString()}
                  </ArgonTypography>
                </ArgonBox>
                
                {/* Table */}
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Description</TableCell>
                        <TableCell>Property</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Vendor</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredExpenses.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>
                            <Box>
                              <Typography variant="body2" fontWeight="medium">
                                {row.description}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {row.unit !== "N/A" && `Unit: ${row.unit}`} {row.recurring && "• Recurring"}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>{row.property}</TableCell>
                          <TableCell>
                            <Stack spacing={0}>
                              <Typography variant="body2">{row.category}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {row.subCategory}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" fontWeight="medium">
                              ${row.amount.toLocaleString()}
                            </Typography>
                          </TableCell>
                          <TableCell>{new Date(row.date).toLocaleDateString()}</TableCell>
                          <TableCell>{row.vendor}</TableCell>
                          <TableCell>{getStatusChip(row.status)}</TableCell>
                          <TableCell align="right">
                            <IconButton 
                              size="small" 
                              onClick={(e) => handleMenuClick(e, row)}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                
                {/* Table pagination or "showing x of y entries" would go here */}
                <ArgonBox mt={2} display="flex" justifyContent="flex-end">
                  <ArgonTypography variant="body2" color="text">
                    Showing {filteredExpenses.length} of {expenses.length} expenses
                  </ArgonTypography>
                </ArgonBox>
              </ArgonBox>
            </Card>
          </Grid>
        </Grid>
      </ArgonBox>
      
      {/* Action menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleAction('view')}>View Details</MenuItem>
        <MenuItem onClick={() => handleAction('edit')}>Edit Expense</MenuItem>
        <MenuItem onClick={() => handleAction('delete')}>Delete</MenuItem>
        <MenuItem onClick={() => handleAction('attachments')}>
          View Attachments ({selectedExpense?.attachments || 0})
        </MenuItem>
      </Menu>
      
      <Footer />
    </DashboardLayout>
  );
}

export default Expenses;